import React, { useState, useRef, useEffect } from "react";
import { api } from "../api";

export default function ResetPassword({ token, onDone }) {
  const [password, setPassword]   = useState("");
  const [confirm, setConfirm]     = useState("");
  const [error, setError]         = useState("");
  const [done, setDone]           = useState(false);
  const [loading, setLoading]     = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;
    return () => { mountedRef.current = false; };
  }, []);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (password.length < 6) {
      setError("La password deve avere almeno 6 caratteri.");
      return;
    }
    if (password !== confirm) {
      setError("Le due password non coincidono.");
      return;
    }

    setLoading(true);
    try {
      await api.resetPassword(token, password);
      if (mountedRef.current) setDone(true);
    } catch (err) {
      if (mountedRef.current) setError(err.message);
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-institution">
          <span className="login-dept">Dipartimento di Oncologia Sperimentale</span>
          <h1>Reimposta password</h1>
          <p className="login-subtitle">Scegli una nuova password per il tuo account.</p>
        </div>

        {done ? (
          <>
            <p className="login-success">✓ Password aggiornata correttamente.</p>
            <button className="btn-primary" onClick={onDone}>Vai al login</button>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            <label>
              <span>Nuova password</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="new-password"
                placeholder="••••••••"
                autoFocus
                required
              />
            </label>
            <label>
              <span>Conferma password</span>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                autoComplete="new-password"
                placeholder="••••••••"
                required
              />
            </label>

            {error && <p className="login-error">⚠ {error}</p>}

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? "Salvataggio…" : "Reimposta password"}
            </button>
          </form>
        )}

        {!done && <button className="login-link" onClick={onDone}>← Torna al login</button>}
      </div>
    </div>
  );
}
